import { TApplicationState } from '../../types/referrer/store';

export const selectReferralsList = (state: TApplicationState) => state.referral;
